import styled from '@emotion/styled'
import { FlexBox } from 'app/components/Layout/FlexBox'
import React, { memo } from 'react'

export interface Props {
  className?: any
  isSticky?: boolean
  onClick?: () => void
}

export const Hamburger = memo(function Hamburger({
  className,
  isSticky,
  onClick,
}: Props) {
  return (
    <Container
      className={`${className} ${isSticky ? 'is-sticky' : undefined}`}
      onClick={onClick}
    >
      <Line />
      <Line />
      <Line />
    </Container>
  )
})

const Container = styled(FlexBox)`
  width: 3rem;
  height: 3rem;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.variants.neutralDark2};
  cursor: pointer;
  position: relative;

  &:hover {
    > div {
      &:nth-of-type(1) {
        left: 50%;
      }
      &:nth-of-type(3) {
        right: 50%;
      }
    }
  }

  @media (max-width: 1199px) {
    width: 2.25rem;
    height: 2.25rem;
    margin-top: 1.125rem;
    margin-bottom: 1.125rem;
    background: transparent;
  }
`

const Line = styled.div`
  height: 0.0625rem;
  background: ${({ theme }) => theme.colors.variants.neutralLight4};
  position: absolute;
  right: 0.8125rem;
  left: 0.8125rem;
  transition: 0.3s cubic-bezier(0, 0.55, 0.45, 1);

  &:nth-of-type(1) {
    top: 1.25rem;
  }
  &:nth-of-type(2) {
    top: 1.4375rem;
  }
  &:nth-of-type(3) {
    top: 1.625rem;
  }

  @media (max-width: 1199px) {
    background: ${({ theme }) => theme.colors.variants.neutralDark3};
    right: 0;
    left: 0;

    &:nth-of-type(1) {
      top: 0.75rem;
    }
    &:nth-of-type(2) {
      top: 1.125rem;
    }
    &:nth-of-type(3) {
      top: 1.5rem;
    }
  }
`
